export default {
    intro: 'ดูความหมายแล้วเลือกคำที่ถูกต้องกันเลย!',
    th: {
        order: 'ลำดับ',
        meaning: 'โจทย์',
        answer: 'คำตอบที่ถูก',
        wrong: 'คำตอบที่ผิด',
        wrongChoices: 'ตัวเลือกคำตอบผิด',
        correctRate: 'อัตราการตอบถูก',
    },
    manySelectedWrongAnswer: 'คำตอบผิดที่ถูกเลือกมากที่สุด',
    teacher: {
        setting: {
            addQuestion: 'เพิ่มโจทย์',
            searchCount: 'ผลการค้นหา {count} รายการ',
            defaultBadge: 'พื้นฐาน',
            otherCount: 'และอีก {count} รายการ',
            waitHeader: 'คำศัพท์ที่รอลงทะเบียน ({count})',
            clearAll: 'ล้างทั้งหมด',
            registerCount: 'ลงทะเบียน {count} รายการในกิจกรรม',
            sameWordBadge: 'คำหลักเหมือนกัน',
            emptyMeaningBadge: 'ไม่มีความหมาย',
            autoExtract: 'สกัดอัตโนมัติ',
            delete: 'ลบ',
            close: 'ปิด',
        },
        modal: {
            clearConfirm: {
                title: 'จะล้างคำศัพท์ที่รออยู่ทั้งหมดไหม?',
                message: 'คำศัพท์ที่รอลงทะเบียนจะถูกลบทั้งหมด ต้องการดำเนินการต่อหรือไม่?',
            },
            closeConfirm: {
                title: 'จะลบโจทย์ที่กรอกไว้ไหม?',
                message: 'หากปิด คำศัพท์ในคิวจะหายไปทั้งหมด ต้องการดำเนินการต่อหรือไม่?',
            },
            questionDelete: {
                title: 'จะลบโจทย์ไหม?',
                // {word}: 삭제 대상 문항의 정답(표제어). 활동에서 영구 제거됨을 안내.
                message: "โจทย์ '{word}' จะถูกลบออกจากกิจกรรม ต้องการดำเนินการต่อหรือไม่?",
            },
            waitItemDelete: {
                title: 'จะลบคำศัพท์ที่รออยู่ไหม?',
                // {word}: 삭제 대상 대기 어휘(정답 단어). 대기열에서만 제거되며 활동에는 영향 없음을 안내.
                message: "จะลบ '{word}' ออกจากคิว ต้องการดำเนินการต่อหรือไม่?",
            },
            // {count}: BE가 사전 중복으로 건너뛴 어휘 수
            duplicateNotice: 'คำศัพท์ {count} คำที่ลงทะเบียนไว้แล้วไม่ถูกเพิ่ม',
            // {count}: 뜻이 없어 등록 불가로 건너뛴 어휘 수
            skippedNotice: 'คำศัพท์ {count} คำไม่ถูกลงทะเบียนเพราะไม่มีความหมาย',
            // 혼합(뜻없는 어휘 + 뜻있는 어휘) 등록 시 확인 모달
            mixedEmptyConfirm: {
                title: 'จะลงทะเบียนไหม?',
                // {empty}: 뜻 비어 등록 불가 개수
                line1: 'คำศัพท์ {empty} คำที่ไม่มีความหมายจะไม่ถูกเพิ่ม',
                // {valid}: 실제 등록될 개수
                line2: 'จะลงทะเบียนเฉพาะ {valid} คำที่เหลือในกิจกรรมไหม?',
            },
            // 뜻없는 어휘만 있을 때 등록 불가 안내
            onlyEmptyNotice: {
                title: 'ไม่สามารถลงทะเบียนได้',
                message: 'ไม่มีคำศัพท์ที่ลงทะเบียนได้ เหลือแต่คำศัพท์ที่ไม่มีความหมายเท่านั้น',
            },
            registerFailed: 'ลงทะเบียนไม่สำเร็จ',
        },
    },
};
